export default window.AmazonCognitoAdvancedSecurityData
